import React, {FC} from "react"

import {Row, Col} from "react-bootstrap"
import {FormattedMessage} from "@irati/utils/lang"
import {H5, Label} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import Spacing from "@irati/ui/src/Spacing"
import {TextButton} from "@irati/ui/src/Button"
import StepIndicatorDots from "@irati/ui/src/StepIndicatorDots"

export interface Step {
  title: string
  content: string
  image: string
  currentStep: number
}

interface Props {
  steps: Step
  completeStep: () => void
}

const StepsCount = 3

const OnboardingCard: FC<Props> = ({steps, completeStep}) => (
  <Card noBorder>
    {/* Desktop Onboarding Icon */}
    <Row>
      <Col xsHidden smHidden md={12} align="center">
        <Spacing marginBottom>
          <img src={steps.image} alt="reward-onboarding-logo" />
        </Spacing>
      </Col>
    </Row>
    <H5>
      <FormattedMessage id={steps.title} />
    </H5>
    <Label display="inline-block" large marginTop={3}>
      <FormattedMessage id={steps.content} />
    </Label>
    {/* Mobile Onboarding Icon */}
    <Row>
      <Col xs={12} mdHidden lgHidden align="center">
        <Spacing marginTop={3} marginBottom={4}>
          <img src={steps.image} alt="reward-onboarding-logo" />
        </Spacing>
      </Col>
    </Row>
    <Row>
      <Col xs={6} mdHidden lgHidden>
        <StepIndicatorDots stepCount={StepsCount} currentStep={steps.currentStep} />
      </Col>
      {steps.currentStep === StepsCount - 1 && (
        <Col xsOffset={1} xs={5} mdHidden lgHidden align="end">
          <TextButton onClick={completeStep}>
            <FormattedMessage id="wallet.reward.onboarding.section.doNotShowAgain.button" />
          </TextButton>
        </Col>
      )}
    </Row>
  </Card>
)

export default OnboardingCard
